// extracted by mini-css-extract-plugin
module.exports = {"Discuss":"Discuss_Discuss__3x7hq","Text":"Discuss_Text__oUxu2","Button":"Discuss_Button__2avN9"};